export const keys = [
  { label: 'Newest',
    key: 'created_dtm desc' },
  { label: 'Oldest',
    key: 'created_dtm asc' },
  { label: 'Highest Rating',
    key: 'overall_rating desc,created_dtm desc' },
  { label: 'Lowest Rating',
    key: 'overall_rating asc,created_dtm desc' },
];
